import * as Sentry from '@sentry/react'
import { detectPlatform } from '../analytics/platform'

let initialized = false

export function initSentry() {
  if (initialized) return true

  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return false

  const environment = (import.meta.env.VITE_SENTRY_ENV || import.meta.env.VITE_APP_ENV) as string | undefined
  const release = import.meta.env.VITE_APP_VERSION as string | undefined
  const platform = detectPlatform()

  try {
    Sentry.init({
      dsn,
      environment,
      release,
      sendDefaultPii: false,
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      integrations: (integrations) =>
        integrations.filter((integration) => integration.name !== 'BrowserTracing' && integration.name !== 'Replay'),
      beforeSend: (event) => {
        event.tags = { ...event.tags, platform, app_env: environment, app_version: release }
        return event
      },
    })

    Sentry.setTag('platform', platform)
    if (environment) Sentry.setTag('app_env', environment)
    if (release) Sentry.setTag('app_version', release)

    if (typeof window !== 'undefined') {
      // Expose for manual console testing: window.__Sentry.captureException(...)
      ;(window as any).__Sentry = Sentry
    }

    initialized = true
    return true
  } catch (err) {
    console.warn('[sentry] init failed', err)
    return false
  }
}

export { Sentry }
